import { Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts";
import { useEffect, useState } from "react";
import GraphContainer from "../../pages/AnalyticsPage/GraphContainer";

/**
 * More readable labels for the alert types
 */
const alertTypeLabels = {
  type1: "Alert Type 1",
  type2: "Alert Type 2",
  type3: "Alert Type 3",
};

/**
 * Fetches number of each type of alert from JSON file and formats them for graph
 * @returns
 */
async function fetchAlertTypes() {
  try {
    const res = await fetch("data/alert-types.json"); // placeholder data
    if (!res.ok)
      console.error(
        "Error fetching resolution alert types, did not return 200 response"
      );
    const json = await res.json();

    // create array of alerts types and adds labels to them
    const alertTypes = [];
    for (const alert in json) {
      alertTypes.push({
        id: alert,
        value: json[alert],
        label: alertTypeLabels[alert] || alert,
      });
    }
    return alertTypes;
  } catch (error) {
    console.error("Error fetching alert types: ", error);
  }
}

export default function AlertTypeGraph() {
  const [alertTypes, setAlertTypes] = useState(null);

  useEffect(() => {
    fetchAlertTypes().then((alertType) => setAlertTypes(alertType));
  }, []);

  if (!alertTypes) return <Typography variant="p">Loading...</Typography>;

  return (
    <GraphContainer header={"Alert Types"}>
      <PieChart
        series={[
          {
            data: alertTypes,
          },
        ]}
      />
      <br/><br/><br/>
    </GraphContainer>
  );
}
